export const listByIdNameDenominationStatus = [
    {ID: 'All', NAME: 'All'},
    {ID: 'proposed', NAME: 'Proposed'},
    {ID: 'published', NAME: 'Published'},
    {ID: 'approved', NAME: 'Approved'},
    {ID: 'rejected', NAME: 'Rejected/Withdrawn'},
    {ID: 'cancelled', NAME: 'Cancelled'},
];
